import { genCodeController } from "..";
import { BackendTemplate } from "../../model/model/gencode/BackendTemplate";
import { FileCodeBackend } from "../../model/model/gencode/FileCodeBackend";
import { ConfigSequelize } from "../../model/setup-sequelize/ConfigSequelize";
import { VariableTemplate } from "../../model/setup-sequelize/EVariableTemplate";
import { Model } from "../../model/setup-sequelize/Model";
import { BaseController } from "../fake/BaseController";
import _ from "lodash";
var fileDownload = require("js-file-download");


const configSequelize: ConfigSequelize = {
	dialect: "postgres",
	name: "my-project",
	singularTableNames: true,
	snake: true,
	softDeletes: false,
	timestamps: false,
};
export class TableSequelizeController extends BaseController<FileCodeBackend> {
	replaceCode(templates: BackendTemplate, tables: Model[]): string {
		let content = ``;
		tables.map((table) => {
			const getTemplate = _.cloneDeep(templates);
			const variables = [
				{
					preview: genCodeController.renderFields(
						table.fields || [],
						configSequelize
					),
					variable: [VariableTemplate.SEQUELIZE_MODEL],
				},
				{
					preview: genCodeController.keyAndType(table.fields || []),
					variable: [VariableTemplate.INTERFACE],
				},
				{
					preview: _.camelCase(table.name || ""),
					variable: [VariableTemplate.NAME_CAMELS_CASE],
				},
				{
					preview: _.upperFirst(_.camelCase(table.name || "")),
					variable: [VariableTemplate.NAME_CAMELS_CASE_UPPER_FIRST],
				},
				{
					preview: _.snakeCase(table.name || ""),
					variable: [VariableTemplate.NAME_SNACK_CASE],
				},
			];
			getTemplate.fileTemplates?.map((file) => {
				variables.forEach((variable) => {
					const varName = "{" + variable.variable + "}";
					file.template = file.template?.replace(
						new RegExp(varName, "g"),
						variable.preview || varName
					);
					file.template = file.template?.replace(
						new RegExp('"', "g"),
						"'" || varName
					);
					file.name = file.name?.replace(
						new RegExp(varName, "g"),
						variable.preview || varName
					);
				});
				console.log(file.name)
				content += `
                touch ${file.path}/${file.name}
                `;
				content += `exec 3<> ${file.path}/${file.name}
                echo "
${file.template}" >&3 
exec 3>&-
`;
			});
		});

		return content;
	}
    async downloadCode(code: string) {
		// console.log(code)
		fileDownload(code, "genCode.sh");
	}
}
